import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteInsuredLocation = () => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = ({ customerId, insuredLocationId }: { customerId: string; insuredLocationId: string }) => {
    return client
      .delete(`customer/${customerId}/insured-location/${insuredLocationId}`)
      .then(() => ({ customerId, insuredLocationId }));
  };

  const result = useMutation({
    mutationFn,
    onSuccess: (_, { customerId }) => {
      queryClient.invalidateQueries({ queryKey: customerQueryKey._customerLocation(customerId) });
    },
  });

  return { ...result, deleteInsuredLocationAsync: result.mutateAsync };
};
